<template>
    <!-- 二次封装上传组件 -->
    <div class="upload-block ub">
        <el-upload
            :accept="accept"
            :headers="headers"
            :action="uploadAction"
            :on-success="handleAddSuccess"
            :before-upload="beforeUpload"
            list-type="picture-card"
            :file-list="fileList"
            :disabled="disabled"
        >
            <i class="el-icon-plus avatar-uploader-icon">
                <span class="el-upload__tip upload-tip">上传</span>
            </i>
             <div  v-if="fileList && fileList.length > 0" class="divImg" slot="file" slot-scope="{file}">
                <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url" alt=""
                >
                <span class="el-upload-list__item-actions">
                    <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                    >
                    <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                    v-if="isDel"
                    class="el-upload-list__item-delete"
                    @click="handleOnRemove(file)"
                    >
                    <i class="el-icon-delete"></i>
                    </span>
                </span>
                </div>
        </el-upload>
        <el-dialog 
            append-to-body 
            :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "upload",
    data() {
        return {
            headers: {
                Authorization: localStorage.getItem("accessToken")
            },
            // 上传的服务器api地址
            uploadAction: `${this.$store.state.apiUrl}/api/File/UploadImage`,
            accept: ".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
            fileList: [],
            dialogVisible: false,
            dialogImageUrl: ''
        };
    },
    props: {
        value: {
            type: Array | String,
            default:  () => {
                return []
            }
        },
        //   最大上传个数
        limit: {
            type: Number,
            default: 1
        },
        // 当前图片值, 用于编辑回显
        imgList: {
            type: Array,
            default: () => {
                return []
            }
        },
        index:{
         type: Number,
            default: 0
        },
        // 图片尺寸
        size: {
            type: Number,
            default: 2
        },
        // 是否只读
        disabled: {
            type: Boolean,
            default: false
        },
        // 是否只读
        imgbled: {
            type: Boolean,
            default: false
        },
        // 监听关闭
        isClear: {
            type: Boolean,
            default: true
        },
        // 是否可以删除
        isDel: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        // 上传之前检查是否符合条件
        beforeUpload(file) {
            const isLt2M = file.size / this.size / 1024 / 1024 < 1;
            if (!isLt2M) {
                this.$message.error(`上传图片大小不能超过${this.size}M!`);
                return false;
            }
            
            return true;
        },
        // 上传成功
        handleAddSuccess(response, file, fileLists) {
            if (response.code !== 200) {
                this.$message.error(response.msg);
                fileLists.splice(fileLists.length - 1, 1)
                return
            }
            if ( this.fileList.length === this.limit ) {
                this.fileList.splice(this.limit-1, 1, file)
            } else {
                this.fileList.push(file);
            }
            
        },
        // 文件移除
        handleOnRemove(file) {
            this.fileList.splice(this.fileList.indexOf(file) ,1)
            // this.fileList = fileList;
        },
          // 外部清除
        clear() {
            this.fileList = []
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        }
    },
    watch: {
        isClear(newVal) {
            if (!newVal) this.clear()
        },
        fileList(newVal) {
            if (!newVal) return false
            let imgList = [];
            if (newVal.length === 0) {
                this.$emit("getImgList", []);
                return false;
            }
            newVal.map(item => {
                let data = item.response ? item.response.data : item
                imgList.push(data)
            })
            this.$emit("getImgList", imgList, this.index);
            return true;
        },
        imgbled(e){
            if (e) {
                this.fileList = []
            }
        },
        // 这里主要是编辑的时候回显用
        imgList(newVal) {
            this.fileList = [];
            if (newVal === 0) {
                return false;
            }
            // 判断是否为编辑，需要转换为照片墙所需格式
            this.imgList.map(item => {
                this.fileList.push({
                    name: item.imageUrl,
                    url: item.showImageDomain + item.imageUrl,
                    response: {
                        data: {
                            showImageDomain: item.showImageDomain,
                            imageUrl: item.imageUrl
                        }
                    }
                })
            })
            return true;
        },
        value(newVal) {
            if (!newVal || this.fileList.length > 0) return false
            let arr = []
            typeof newVal === 'object' ? arr = newVal : arr = newVal.split(',')
            arr.map(item => {
                this.fileList.push({
                    name: item,
                    imageUrl: item,
                    url: previewUrl + item,
                })
            })
        }
    }
};
</script>
<style lang="scss" scoped>
// @import "../../assets/scss/variable.scss";
.upload-block,
.img-list {
    flex: 1;
    display: flex;
    align-items: center;
}
.img-list {
    background: transparent;
}
.divImg {
    height: 100%!important;
}

</style>
